import {makeStyles, Theme} from '@material-ui/core';
import React, { cloneElement } from 'react';
import {Edit, ReferenceArrayInput, SelectArrayInput, ChipField, ImageField, ImageInput, required, SimpleForm, NumberInput, TextInput, Toolbar, SaveButton, DeleteButton, ReferenceInput, SelectInput, BooleanInput} from 'react-admin';
import {Messages} from '../../consts/Messages';
import {COUNTRIES, FIXED_COLUMN_CATEGORY, CURRENCIES, CITIES, AREAS, SMS_PROVIDERS} from '../../consts/Names';
import {Validators} from '../../consts/Validators';

const useStyles = makeStyles((theme: Theme) => ({
   form: {
      display: 'flex',
      flexDirection: 'column'
   },

   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   },
   toolBar:{
      flex: 1,
      display: "flex",
      "justify-content": "space-between"
   },
}));


const validateStock = [required(), Validators.minValue(3, Messages.MIN_VALUE)];
const validateHair = [required(), Validators.minValue(3, Messages.MIN_VALUE)];

const NameField = ({source, record={} , label = "", children, ...props}) => {   
   let disabled = (record as any).name === FIXED_COLUMN_CATEGORY;
   let validate = (record as any).name === FIXED_COLUMN_CATEGORY ? validateHair : validateStock;
   return cloneElement( children,  {disabled, validate, source, record,   props})
}
const EditToolbar = (props) => (
   <Toolbar {...props}  className={props.className}>
      <SaveButton submitOnEnter={false} variant="text" />
      {props.record.name !== FIXED_COLUMN_CATEGORY && <DeleteButton  undoable={false}/>}      
   </Toolbar>
);

export const CountriesEdit = (props) => {
   const {theme} = props;
   const classes = useStyles(theme);
   return (<Edit {...props}  undoable={false} title="Edit country" >
      <SimpleForm toolbar={<EditToolbar {...props} className={classes.toolBar}/>}>
         <NameField source={COUNTRIES.name}>
            <TextInput className={classes.textFld} label="Name" source={COUNTRIES.name} />
         </NameField>
         <ReferenceInput className={classes.textFld} label="Currency" source={COUNTRIES.currency_id} reference="currencies" validate={[required()]}>
            <SelectInput source={CURRENCIES.id} />
         </ReferenceInput>
         <ImageInput
            className={classes.imageFld}
            multiple={false}
            source={COUNTRIES.flag}
            label="Flag"
            accept="image/*"
            placeholder={<p>Drop your image here</p>}>
                <ImageField source={'src'} />
         </ImageInput>
         <BooleanInput source={COUNTRIES.visibility} label='Visibility' />
         <NumberInput source={COUNTRIES.min_phone_lenght} />
         <NumberInput source={COUNTRIES.max_phone_lenght} />
         <TextInput className={classes.textFld} label="Phone number mask" source={COUNTRIES.phone_mask} />
         <TextInput className={classes.textFld} label="Country phone code" source={COUNTRIES.phone_code} />
         <TextInput className={classes.textFld} label="Slack notification channel" source={COUNTRIES.slack_notification_channel} />
         <ReferenceInput className={classes.textFld} label="Sms Provider" source={COUNTRIES.sms_provider_id}  perPage={500} reference={SMS_PROVIDERS.SOURCE}>
            <SelectInput source={SMS_PROVIDERS.id} />
         </ReferenceInput>
         <ReferenceArrayInput
             className={classes.textFld}
             source={COUNTRIES.major_cities}
             label="Major cities"
             reference={CITIES.SOURCE}
             filter={{ country_id: props.id }}
             perPage={1000}>
            <SelectArrayInput >
               <ChipField source={'name'}/>
            </SelectArrayInput>
         </ReferenceArrayInput>
      </SimpleForm>
   </Edit>
)
}
